/** Human-readable Atera alert open/archived state (from is_active / Archived flag). */

export function alertStatusLabel(isActive) {
  return isActive ? 'Open' : 'Archived'
}

export function alertStatusSortValue(isActive) {
  return isActive ? 0 : 1
}
